// @flow

import React from 'react';
import { observer } from 'mobx-react';
import { css } from 'glamor';

import BrowseMenuEntry from '~/components/global/BrowseMenuEntry';
import type { MenuEntry } from '~/types';

const list = css({
    listStyle: 'none',
    paddingLeft: 0,
});

@observer
export default class BrowseMenu extends React.Component {
    props: {
        entries: Array<MenuEntry>,
        icon: string,
    };

    render() {
        const { entries = [], icon } = this.props;

        return (
            <ul { ...list }>
                {entries.map(entry => (
                    <BrowseMenuEntry
                        entry={ entry }
                        key={ entry.link }
                        icon={ icon }
                    />
                ))}
            </ul>
        );
    }
}



// WEBPACK FOOTER //
// ./src/components/global/BrowseMenu/index.js